module.exports = __webpack_public_path__ + "static/media/viewed.81983091.svg";